module.exports = __webpack_public_path__ + "d13.no2.a2550cbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d13.no2.jpg
// module id = 5gvU
// module chunks = 0